import { EXTERNAL_POPUP_TIMEOUT } from '@yme/hooks/constants';
import { hasValidSession } from '@yme/hooks/useAuthorization';
export const manageExternalLoginWindow = ({ externalPopup, setExternalPopup, redirectStep, successCb, }) => {
    const timer = setInterval(() => {
        if (!externalPopup) {
            timer && clearInterval(timer);
            return;
        }
        if (externalPopup.closed) {
            setExternalPopup(null);
            timer && clearInterval(timer);
            return;
        }
        if (hasValidSession()) {
            clearInterval(timer);
            setExternalPopup(null);
            externalPopup.close();
            successCb?.();
            if (redirectStep) {
                window.location.hash = `#${redirectStep}`;
            }
        }
    }, EXTERNAL_POPUP_TIMEOUT);
    return () => {
        clearInterval(timer);
    };
};
